import { ExpertRole } from "@/features/experts/types/ExpertRole";
import { AppointmentStatus } from "@/utils/enums/Consults";
import { Appointment } from "../types/Appointment";

export const filterAppointments = {
    byStatus: (appointments: Appointment[], status: AppointmentStatus): Appointment[] =>
        appointments.filter((a) => a.status === status),

    isFuture: (appointment: Appointment): boolean =>
        appointment.remainingMinutes > -30,

    isPast: (appointment: Appointment): boolean =>
        appointment.remainingMinutes <= -30,

    isNutritionist: (appointment: Appointment): boolean =>
        appointment.expert.role === ExpertRole.Nutritionist,

    isExpert: (appointment: Appointment): boolean =>
        appointment.expert.role === ExpertRole.Specialist ||
        appointment.expert.role === ExpertRole.Physician,
};
